import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormSelect from "Common/Custom/FormSelect";
import Switch from "Common/Custom/Switch";
import FormDatePicker from "Common/Custom/ReactFlatpickr";
import FormInputFile from "Common/Custom/FormInputFile";

const EditPoolPackageForm = ({
    fields = [],
    values = {},
    errors = {},
    handleChange = () => {},
    handleSubmit = () => {},
    loading = false,
    handleFileChange = () => {},
    imagePreview = "",
    PooNameOptions = [],
}) => {
    return (
        <PageBody
            headerchildren={<HeadingOne>Update Pool Package</HeadingOne>}
            onSubmit={handleSubmit}
        >
            {fields.map((field) => {
                if (field.type === "file") {
                    return (
                        <FormInputFile
                            key={field.name}
                            field={field}
                            handleChange={handleFileChange}
                            error={errors[field.name]}
                            imagePreview={imagePreview}
                        />
                    );
                }
                if (field.type === "select") {
                    // Guard against undefined while pool names are loading
                    const options = (PooNameOptions || []).map((opt) => ({
                        value: opt.swimming_pool_id,
                        label: opt.s_pool_name,
                    }));
                    return (
                        <FormSelect
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            options={options}
                            error={errors[field.name]}
                        />
                    );
                }
                if (field.type === "switch") {
                    return (
                        <Switch
                            key={field.name}
                            values={values[field.name]}
                            handleChange={handleChange}
                            error={errors[field.name]}
                            field={field}
                            ValueOne="1"
                            ValueTwo="0"
                            LabelOne="Active"
                            LabelTwo="Inactive"
                        />
                    );
                }
                if (field.type === "date") {
                    // For to_date: dynamically set minDate to the selected from_date
                    // Pass via options prop (not field.minDate) so Flatpickr reacts to changes
                    const extraOptions = field.name === "to_date" && values.from_date
                        ? { minDate: values.from_date }
                        : {};
                    return (
                        <FormDatePicker
                            key={field.name}
                            field={field}
                            value={values[field.name] || ""}
                            handleChange={handleChange}
                            error={errors[field.name]}
                            mode="date"
                            options={extraOptions}
                        />
                    );
                }
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Update Pool Package"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default EditPoolPackageForm;
